import React, { useState, useEffect } from 'react'
import { withRouter } from 'react-router-dom'
import { connect, useDispatch, useSelector } from 'react-redux'
import SidePopup from '../../SidePopupNew'
import Edit from './edit'
import View from './view'
import * as OperatorAct from '../../../redux/actions/operators'

const Operators = ({ user, history, operators, brands, delegations }) => {
  const params = new URLSearchParams(history.location.search)
  const company = useSelector(store => store.companies)
  const dispatch = useDispatch()
  const [operator, setOperator] = useState({
    name: '',
    lastname: '',
    email: '',
    role: '',
    company: user.company || '',
    brands: [],
    delegations: [],
    brandNames: [],
    delegationNames: [],
    available: false,
    isAutomaticAssigned: false,
    maxConversationAssigned: 0,
    channelPriority: [],
    onlyAssignedConversations: false
  })
  const [type, setType] = useState('view')

  useEffect(()=>{
    if (Object.entries(operators).length === 0)
      dispatch(OperatorAct.getOperators({ idCompany: company._id }))
    else
      setOperator(operators[params.get('id')])
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [operators])

  useEffect(() => {
    if (params.get('id')) {
      setType('view')
      if (operators.length > 0)
        setOperator(operators[params.get('id')])
    } else {
      setType('add')
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [params.get('id')])

  const handleChange = ({ target }) => setOperator({ ...operator, [target.name]: target.value })
  const handleHideModal = () => history.goBack()
  const handleEditModal = () => setType('edit')
  return (
    <SidePopup onHide={handleHideModal}>
      {(type === 'add' || type === 'edit') ? <Edit onHideModal={handleHideModal} onChange={handleChange} {...{ operator, type }} /> : null}
      {type === 'view' ? <View onHideModal={handleHideModal} onEditModal={handleEditModal} {...{ operator, brands, delegations }} /> : null}
    </SidePopup>
  )
}

function mapStateToProps(state) {
  return {
    user: state.user,
    brands: state.brands,
    delegations: state.delegations,
    company: state.companies,
    operators: state.operators,
  }
}

export default connect(mapStateToProps, null)(withRouter(Operators))
